/* eslint-disable camelcase */
/* eslint-disable quotes */

function escapeHtml(str) {
  if (!str) return '';

  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

function capitalize(str) {
  if (!str) return '';

  return str.charAt(0).toUpperCase() + str.slice(1);
}

function capitalizeWords(str) {
  return str.split(' ').map(capitalize).join(' ');
}

// gclid=123&utm_campaign=spring_sale&utm_source=google&utm_medium=cpc&utm_term=best_sellers&utm_content=ad1&fbclid=456
function getUrlParamsForForm() {
  const params = new URLSearchParams(window.location.search);
  const keys = [
    'gclid',
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content',
    'fbclid',
  ];
  const result = {};
  keys.forEach((key) => {
    if (params.has(key)) result[key] = params.get(key);
  });

  return result;
}

function populateUtmInputs() {
  const utmParams = getUrlParamsForForm();
  const keyParameters = [
    'gclid',
    'utm_campaign',
    'utm_source',
    'utm_medium',
    'utm_term',
    'utm_content',
    'fbclid',
  ];

  for (const param of keyParameters) {
    if (utmParams[param]) {
      const input = document.querySelector(`input[data-utm="${param}"]`);
      if (input) input.setAttribute('value', utmParams[param]);
    }
  }
}

function showError(container, message, duration = 3000) {
  if (!container) return;
  container.innerText = message;
  container.classList.remove('hidden');
  if (duration > 0) {
    setTimeout(() => {
      container.classList.add('hidden');
    }, duration);
  }
}

async function submitForm(event) {
  event.preventDefault();
  event.stopPropagation();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const submitFlag = document.querySelector('#q')?.value;
  const errorTextContainer = document.querySelector('.error-message');
  if (submitFlag !== 'true') return;
  if (window.Shopify?.huntsman?.isRobot) return;

  const pageLoadedAt = window.Shopify?.huntsman?.pageLoadedAt;
  if (pageLoadedAt) {
    const timeSpent = (Date.now() - pageLoadedAt) / 1000;
    if (timeSpent < 3) {
      if (window.Shopify?.huntsman) {
        window.Shopify.huntsman.isRobot = true;
      }
      showError(errorTextContainer, 'Submission too fast. Please review your details.', 4000);

      return;
    }
  }

  const form = event.target;
  const getVal = (selectorOrName) => {
    const el = form.querySelector(selectorOrName) || form.elements[selectorOrName];

    return el ? el.value.trim() : '';
  };

  const title = getVal('#ContactForm_title') || getVal('contact[title]');
  const firstName = getVal('#ContactForm_first_name') || getVal('contact[firstName]');
  const lastName = getVal('#ContactForm_last_name') || getVal('contact[lastName]');
  const name = [firstName, lastName].filter(Boolean).join(' ');
  const email = getVal('#ContactForm_email') || getVal('contact[email]');
  const phone =
    getVal('#ContactForm_phone') || getVal('contact[Phone number]') || getVal('contact[phone]');
  const city =
    getVal('#selected_city') ||
    getVal('contact[city]') ||
    getVal('#AddressCountryNew') ||
    getVal('address[country]');
  const interestedIn = getVal('#ContactForm_services') || getVal('servicesInterestedIn');
  const userComment = getVal('#ContactForm_body') || getVal('contact[Comment]');

  if (!userComment) {
    showError(errorTextContainer, 'Please type a meaningful message', 3000);

    return;
  }

  if (/^\w+$/.test(userComment) || /^\d+$/.test(userComment)) {
    showError(errorTextContainer, 'Please type a meaningful message', 3000);

    return;
  }

  const commentWords = userComment.split(/\s+/).filter(Boolean);
  if (commentWords.length < 3) {
    showError(errorTextContainer, 'Please type a meaningful message', 4000);

    return;
  }

  const messageHtml = `<br>Interested in the following service:<br>- ${escapeHtml(
    interestedIn
  )}<br>Message:<br>- ${escapeHtml(userComment).replace(/\n/g, '<br>')}`;

  // Analytics event for contact form
  try {
    const contactForm = document.getElementById('ContactForm');
    let payload = { event_name: 'book_an_appointment_submission' };
    const event_area = contactForm?.dataset?.area ? { event_area: contactForm.dataset.area } : {};
    const event_value = city ? { event_value: `${capitalizeWords(city)}` } : {};

    payload = { ...payload, ...event_area, ...event_value };

    window.Shopify?.analytics?.publish?.('custom_analytics', payload);

    let event_name = 'London_appointment';
    if (city === 'New York') {
      event_name = 'NYC_appointment';
    }

    if (typeof window.meta_custom_event === 'function') {
      window.meta_custom_event(event_name);
    }
    if (typeof window.meta_lead_event === 'function') {
      window.meta_lead_event();
    }

    // need this event for ss tag on GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'custom_form_submit',
      selected_location: city,
    });
  } catch (analyticsError) {
    console.error('Analytics tracking error:', analyticsError);
  }

  const formData = { title, name, email, phone, city, message: messageHtml };
  const urlParams = getUrlParamsForForm();

  let values = "<p>You received a new message from your online store's contact form.</p><hr>";

  for (const key in formData) {
    if (Object.prototype.hasOwnProperty.call(formData, key)) {
      const value = formData[key];
      if (value) {
        if (key === 'message') {
          values += `<p style="margin:0 5px">Notes: ${value}</p>`;
        } else {
          values += `<p style="margin:0 5px">${capitalize(key)}: ${escapeHtml(value)}</p>`;
        }
      }
    }
  }

  const utmParamValues = Object.entries(urlParams);
  if (utmParamValues.length) {
    for (const [key, value] of utmParamValues) {
      if (value) {
        values += `<p style="display:none">${capitalize(key)}: ${escapeHtml(value)}</p>`;
      }
    }
  }

  const submitButton = document.querySelector('#contact-form-submit');
  if (submitButton) submitButton.setAttribute('disabled', 'true');

  const successMessage = document.querySelector('.form-status.form__message');
  const errorMessage = document.querySelector('.form__message.form__error');

  try {
    const response = await fetch('https://sendgrid-email-957148834953.europe-west1.run.app', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: city === 'New York' ? 'ed.turco@huntsmansavilerow.com' : 'e-shop@huntsmansavilerow.com',
        subject: 'New customer message',
        html: values,
      }),
    });

    await sleep(1000);

    if (response.ok) {
      successMessage?.classList.remove('hidden');
      errorMessage?.classList.add('hidden');
      const salesforceForm = document.getElementById('trunk-show-salesforce-form');
      if (salesforceForm) salesforceForm.submit();
    } else {
      errorMessage?.classList.remove('hidden');
      successMessage?.classList.add('hidden');
    }
  } catch (fetchError) {
    console.error('Contact form submission error:', fetchError);
    errorMessage?.classList.remove('hidden');
    successMessage?.classList.add('hidden');
  } finally {
    if (submitButton) submitButton.removeAttribute('disabled');
  }
}

function initContactForm() {
  populateUtmInputs();

  const form = document.getElementById('ContactForm');
  if (form) form.addEventListener('submit', submitForm);

  const successfulSubmission =
    new URLSearchParams(window.location.search).get('success') === 'true';
  if (successfulSubmission) {
    document.querySelector('.form-status.form__message')?.classList.remove('hidden');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initContactForm);
} else {
  initContactForm();
}
